import Dock from './Dock'

export default Dock;